import { render, staticRenderFns } from "./CreateSubItem.vue?vue&type=template&id=1f203402&"
import script from "./CreateSubItem.vue?vue&type=script&lang=js&"
export * from "./CreateSubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports